import React, { memo } from 'react';
import styled from 'styled-components';

import ComponentDisabler from '@/components/common/Loaders/ComponentDisabler';

import InlineLoader from './InlineLoader';
import { handleLoaderSize, LOADER_SIZE } from './utils/loaderSize';

interface IComponentLoaderProps {
    className?: string;
    children?: React.ReactNode;
    isLoading?: boolean;
    /**
     * When this flag is false, we will keep children alive when loader shows.
     * This will prevent from loss of state.
     * If this flag is true, then when loading state happens, we will unmount
     * you component.
     */
    unmountChildren?: boolean;
    loaderSize?: number | LOADER_SIZE;
    transparent?: boolean;
    bgColor?: string;
}

const ComponentLoader = ({
    className,
    isLoading,
    children,
    unmountChildren,
    loaderSize,
    transparent,
    bgColor,
}: IComponentLoaderProps) => (
    <ComponentDisabler className={className} isDisabled={isLoading} transparent={transparent} bgColor={bgColor}>
        {unmountChildren &&
            (isLoading ? (
                <LoaderWrapper>
                    <InlineLoader size={handleLoaderSize(loaderSize)} data-testid="loader" />
                </LoaderWrapper>
            ) : (
                children
            ))}

        {!unmountChildren && (
            <>
                {children}
                {isLoading && (
                    <LoaderWrapper>
                        <InlineLoader size={handleLoaderSize(loaderSize)} data-testid="loader" />
                    </LoaderWrapper>
                )}
            </>
        )}
    </ComponentDisabler>
);

const LoaderWrapper = styled.div`
    top: 0;
    left: 0;
    min-width: 1.25rem;
    min-height: 1.25rem;
    width: 100%;
    height: 100%;
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
`;

const Memoized = memo(ComponentLoader);
const Styled = styled(Memoized)``;
export default Styled;
